import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { Tooltip } from "react-tooltip";

import { Languages, Regions, SiteCreateAttributes } from "../../../../api/Api";
import { Icon } from "../../../../assets/icons/Icon";
import FormLabel from "../../../login/formLabel/FormLabel";
import Select from "../../../mantine/select/Select";
import styles from "./SiteDetailsForm.module.scss";
import { TYPE_OF_BUSINESS } from "./constants";

type SiteDetailsFormProps = {
  languages: Languages;
  regions: Regions;
  form: ReturnType<typeof useForm<SiteCreateAttributes>>;
  onSubmit: SubmitHandler<SiteCreateAttributes>;
};

export const SiteDetailsForm = ({
  languages,
  regions,
  form,
  onSubmit,
}: SiteDetailsFormProps) => {
  const { handleSubmit, control } = form;

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={styles.siteDetailsForm}
      id="newSiteDetailsForm"
    >
      <Controller
        name="site_type"
        control={control}
        render={({ field }) => (
          <Select
            label={<FormLabel label="Type of Business" />}
            data={TYPE_OF_BUSINESS}
            searchable
            clearable
            {...field}
            value={typeof field.value === "string" ? field.value : ""}
          />
        )}
      />
      <Controller
        name="primary_country"
        control={control}
        render={({ field }) => (
          <Select
            label={
              <div className={styles.titleWithIcon}>
                <FormLabel label="Primary Search Country" />
                <>
                  <a data-tooltip-id="primaryCountry">
                    <Icon iconName="InfoIcon" width="1rem" height="1rem" />
                  </a>
                  <Tooltip
                    style={{ borderRadius: "var(--border-radius)" }}
                    id="primaryCountry"
                    content="Where most of your traffic comes from"
                    place="top"
                  />
                </>
              </div>
            }
            data={Object.entries(regions).map(([key, value]) => ({
              value: String(key), // Ensure value is a string
              label: value.name ?? String(key),
            }))}
            searchable
            clearable
            {...field}
            value={field.value ?? ""}
          />
        )}
      />
      <Controller
        name="primary_language"
        control={control}
        render={({ field }) => (
          <Select
            label={
              <div className={styles.titleWithIcon}>
                <FormLabel label="Primary Language" />
                <>
                  <a data-tooltip-id="primaryLanguage">
                    <Icon iconName="InfoIcon" width="1rem" height="1rem" />
                  </a>
                  <Tooltip
                    style={{ borderRadius: "var(--border-radius)" }}
                    id="primaryLanguage"
                    content="The default language of your site"
                    place="top"
                  />
                </>
              </div>
            }
            data={Object.entries(languages).map(([key, value]) => ({
              value: String(key), // Ensure value is a string
              label: value,
            }))}
            searchable
            clearable
            {...field}
            value={field.value ?? ""}
          />
        )}
      />
    </form>
  );
};
